import type { ReactElement, ReactNode } from 'react'

import { Tooltip, TooltipProvider } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

export type AdminTooltipProps = PropsWithClassName<{
  label?: ReactNode
  children: ReactElement
  delay?: number
  closeDelay?: number
}>

export const AdminTooltip = ({
  children,
  label,
  className,
  delay,
  closeDelay,
}: AdminTooltipProps) => {
  const tooltip = (
    <Tooltip
      label={label}
      classNames={{
        trigger: 'cursor-pointer',
        popup:
          className ??
          'border bg-neutral border-primary text-neutral-content p-2 text-sm',
      }}
    >
      {children}
    </Tooltip>
  )

  if (delay == null && closeDelay == null) {
    return tooltip
  }

  return (
    <TooltipProvider delay={delay} closeDelay={closeDelay}>
      {tooltip}
    </TooltipProvider>
  )
}
